import ReactSnowfall from 'react-snowfall';

export const SnowEffect = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-[10000000]">
      <ReactSnowfall
        snowflakeCount={250}
        radius={[1, 3]}
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
        }}
        wind={[0.1, 1]}
      />
    </div>
  );
};
